module.exports = __webpack_public_path__ + "static/img/NeutMusic.a0dd5098.png";